export default function EventTypeBadge({ input }: { input?: string }) {
  return (
    <>
      {input && (
        <span className={'badge bg-body-secondary fw-bold'}>
          {input.at(0)?.toUpperCase() + input.slice(1)}
        </span>
      )}
    </>
  );
}
